function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  version: "1.0",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M148.8 134.7h21.3v14.2h-21.3v-14.2zm85.1-113.1v-7.5H49.6v255.1h184.2V21.6h.1zm-92.2 181.9V79.9l63.8-29.4V233l-63.8-29.5zm-63.8-161h77.2l-41.8 19.3v159.9l41.8 19.3H77.9V42.5z"
})));